import styled from "styled-components";
import { colors } from "../../../../consts";
import { Heading4, Paragraph2 } from "../../../../components";

export const ManagemenetPageTitle = styled(Heading4)`
  margin: 24px 0 24px;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
`;

export const EmailTemplateHint = styled(Paragraph2)`
  color: ${colors.RAISIN_70};
  line-height: 24px;

  margin-bottom: 24px;
`;

export const EmailTemplateText = styled(Paragraph2)`
  color: ${colors.DARK_RAISIN};
  line-height: 24px;

  padding-left: 16px;
`;
